export default {"src":"/_next/static/media/arrowLeft.35d56772.svg","height":12,"width":16,"blurWidth":0,"blurHeight":0};